// src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { logout } from "../redux/features/authSlice";
import { persistor, RootState } from "../redux/store";
import colors from "../assets/ts/colors";

/* Every admin page passes through here — some routes render outside MainLayout,
   so the page background must be applied at this level to cover them all.
   flow-root stops child top-margins collapsing through and showing white. */
const pageBgStyle: React.CSSProperties = {
    background: colors.backgroundColor,
    minHeight: "100vh",
    backgroundAttachment: "fixed",
    display: "flow-root",
};

interface ProtectedRouteProps {
    children: JSX.Element;
    allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    allowedRoles,
}) => {
    const token = useSelector((state: RootState) => state.auth.token);
    const dispatch = useDispatch();

    if (!token) {
        return <Navigate to="/admin/login" replace />;
    }

    try {
        const decodedToken: any = jwtDecode(token);
        // const userInfo = decodedToken?.userInfo;

        if (!decodedToken) {
            dispatch(logout());
            persistor.purge(); // Clears persisted auth state
            return <Navigate to="/admin/login" replace />;
        }

        return <div style={pageBgStyle}>{children}</div>;
    } catch (error) {
        console.error("Token decoding failed:", error);
        localStorage.setItem("token", "");
        return <Navigate to="/admin/login" replace />;
    }
};

export default ProtectedRoute;
